<template>
  <div class="banner-awaiting-payment">
    <div class="banner-awaiting-payment__text-container">
      <p class="Body3">On-Demand Consultation Status</p>
      <p class="Title1">Complete Your Payment</p>
    </div>

    <pulsate-icon size="large"
                  pulsate-color="red"
                  class="banner-awaiting-payment__right-icon">
      <div class="banner-awaiting-payment__timer">
        <p class="countdown">{{ timerDisplay }}</p>
        <p class="timer-title">Time Left</p>
      </div>
    </pulsate-icon>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PulsateIcon from '@/views/ondemand/components/pulsate-icon.vue';
  import {
    GETTER_ONDEMAND_LATEST_BOOKING,
  } from '@/store/types';

  export default {
    name: 'banner-awaiting-payment',
    components: {
      PulsateIcon
    },
    data() {
      return {
        timerDisplay: null,
        timerReference: null,
      }
    },
    computed: {
      ...mapGetters({
        currentODBooking: GETTER_ONDEMAND_LATEST_BOOKING,
      }),
    },
    mounted() {
      this.countdownTimer();
    },
    destroyed() {
      clearInterval(this.timerReference);
    },
    methods: {
      countdownTimer() {
        this.timerReference = setInterval(() => {
          const currTime = new Date().getTime();
          const deadlineTime = new Date(this.currentODBooking.approvaldeadline).getTime();
          const difference = deadlineTime - currTime;

          const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((difference % (1000 * 60)) / 1000);

          this.timerDisplay = `${minutes.toString().padStart(2, 0)}:${seconds.toString().padStart(2,0)}`;
        }, 1000);
      },
    },
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .banner-awaiting-payment {
    @extend %layout--flex-row-center-x;
    position: relative;
    overflow: hidden;

    &__right-icon {
      position: absolute;
      right: -40px;
      top: -50px;
    }

    &__timer {
      @extend %layout--flex-center-xy;

      .countdown {
        color: #DA2525;
        font-size: 36px;
        font-family: $D-DIN-Bold;
        line-height: normal;
      }

      .timer-title {
        color: #941818;
        font-size: 12px;
        font-family: $D-DIN-Bold;
        text-transform: uppercase;
      }
    }
  }
</style>